import createActionConstants from 'lib/create-action-constants'
import { setAssistantEngineForAnalytics } from 'lib/analytics'

export const constants = createActionConstants('assistant', [
  'EXPORT_STRUCTURED_OUTPUT_CSV',

  'FETCH_ASSISTANT',
  'FETCH_ASSISTANT_SUCCESS',
  'FETCH_ASSISTANT_FAILURE',
  'FETCH_ASSISTANT_TIMEOUT',
  'FETCH_ASSISTANT_CANCELLED',
  'FETCH_ASSISTANT_CANCEL',
  'FETCH_ASSISTANT_UPGRADE_REQUIRED',
  'FETCH_ASSISTANT_NOT_ENTITLED',

  'FETCH_ASSISTANT_SESSIONS',
  'FETCH_ASSISTANT_SESSIONS_SUCCESS',
  'FETCH_ASSISTANT_SESSIONS_FAILURE',

  'FETCH_ALL_ASSISTANT_SESSIONS',
  'FETCH_ALL_ASSISTANT_SESSIONS_SUCCESS',
  'FETCH_ALL_ASSISTANT_SESSIONS_FAILURE',

  'SHARE_ASSISTANT_SESSION',
  'SHARE_ASSISTANT_SESSION_SUCCESS',
  'SHARE_ASSISTANT_SESSION_FAILURE',
  'SET_PENDING_SHARE_SESSION_ID',
  'FETCH_SHARED_ASSISTANT_SESSION',
  'FETCH_SHARED_ASSISTANT_SESSION_SUCCESS',
  'FETCH_SHARED_ASSISTANT_SESSION_FAILURE',

  'SWITCH_SESSION',
  'SWITCH_SESSION_SUCCESS',
  'SWITCH_SESSION_FAILURE',

  'LOAD_OLDER_TURNS',
  'LOAD_OLDER_TURNS_SUCCESS',
  'LOAD_OLDER_TURNS_FAILURE',

  'DELETE_ASSISTANT_SESSIONS',
  'DELETE_ASSISTANT_SESSIONS_SUCCESS',
  'DELETE_ASSISTANT_SESSIONS_FAILURE',

  'RENAME_ASSISTANT_SESSION',
  'RENAME_ASSISTANT_SESSION_SUCCESS',
  'RENAME_ASSISTANT_SESSION_FAILURE',

  'DOWNLOAD_ASSISTANT_REFERENCES',
  'DOWNLOAD_ASSISTANT_REFERENCES_SUCCESS',
  'DOWNLOAD_ASSISTANT_REFERENCES_FAILURE',

  'DOWNLOAD_ASSISTANT_TRANSCRIPT',
  'DOWNLOAD_ASSISTANT_TRANSCRIPT_SUCCESS',
  'DOWNLOAD_ASSISTANT_TRANSCRIPT_FAILURE',

  'NEW_SESSION',

  'LOAD_ASSISTANT_SETTINGS',
  'SET_ASSISTANT_SETTINGS',
  'LOAD_ASSISTANT_SETTINGS_SUCCESS',
  'SET_CHAT_HISTORY_OPEN',

  'SAVE_ASSISTANT_PRESET',
  'SAVE_ASSISTANT_PRESET_SUCCESS',
  'SAVE_ASSISTANT_PRESET_FAILURE',

  'LOAD_ASSISTANT_PRESETS',
  'LOAD_ASSISTANT_PRESETS_SUCCESS',
  'LOAD_ASSISTANT_PRESETS_FAILURE',

  'DELETE_ASSISTANT_PRESET',
  'DELETE_ASSISTANT_PRESET_SUCCESS',
  'DELETE_ASSISTANT_PRESET_FAILURE',

  'UPDATE_ASSISTANT_PRESET',
  'UPDATE_ASSISTANT_PRESET_SUCCESS',
  'UPDATE_ASSISTANT_PRESET_FAILURE',

  'SET_FEEDBACK',
  'SET_FEEDBACK_SUCCESS',
  'SET_FEEDBACK_FAILURE',

  'ASSISTANT_PROGRESS',

  'SET_ASSISTANT_ENGINE',

  'SET_RESPONSE_RATING',

  'SET_CURRENT_TURN',
  'SET_SHARED_CURRENT_TURN',

  'SET_UNLOCKED_SESSION',

  'FETCH_ASSISTANT_USAGE',

  'ASSISTANT_UPDATE_USAGE',

  'SET_COLUMNS',

  'SET_COLUMN_BUSY',

  'SET_COLUMN_FORM',

  'SET_COLUMN_WIZARD',

  'SET_SEARCH_STRATEGY_TURN_INDEX',

  'SET_EXPORT_STRUCTURED_OUTPUT_TURN_INDEX',

  'CLEAR_RESPONSE_JUST_COMPLETED',

  'START_DOCUMENT_UPLOAD',
  'DOCUMENT_UPLOAD_PROGRESS',
  'DOCUMENT_UPLOAD_TASK_ID',
  'DOCUMENT_UPLOAD_SUCCESS',
  'DOCUMENT_UPLOAD_FAILURE',
  'CANCEL_DOCUMENT_UPLOAD',
  'CLEAR_LAST_UPLOAD_ERROR',

  'GENERATE_SUGGESTED_QUESTIONS',
  'GENERATE_SUGGESTED_QUESTIONS_SUCCESS',
  'GENERATE_SUGGESTED_QUESTIONS_FAILURE',

  'GENERATE_SUGGESTED_PROMPTS',
  'GENERATE_SUGGESTED_PROMPTS_SUCCESS',
  'GENERATE_SUGGESTED_PROMPTS_FAILURE',

  'GENERATE_COLLECTION_SUGGESTED_PROMPTS',
  'GENERATE_COLLECTION_SUGGESTED_PROMPTS_SUCCESS',
  'GENERATE_COLLECTION_SUGGESTED_PROMPTS_FAILURE'
])

export const assistantUpdateUsage = payload => ({
  type: constants.ASSISTANT_UPDATE_USAGE,
  payload
})

export const fetchAssistantUsage = () => ({
  type: constants.FETCH_ASSISTANT_USAGE
})

export const switchSession = payload => ({
  type: constants.SWITCH_SESSION,
  payload
})

export const setAssistantEngine = engine => {
  // Mirror the live engine into analytics (the only dispatch path for it) so every Assistant
  // event stamps V1/V2 — kept here rather than in the reducer, which must stay pure.
  setAssistantEngineForAnalytics(engine)
  return { type: constants.SET_ASSISTANT_ENGINE, payload: engine }
}

export const setResponseRating = (key, rating) => ({
  type: constants.SET_RESPONSE_RATING,
  payload: { key, rating }
})

export const loadOlderTurns = () => ({
  type: constants.LOAD_OLDER_TURNS
})

export const deleteAssistantSessions = payload => ({
  type: constants.DELETE_ASSISTANT_SESSIONS,
  payload
})

export const renameAssistantSession = payload => ({
  type: constants.RENAME_ASSISTANT_SESSION,
  payload
})

export const cancelFetchAssistant = taskId => ({
  type: constants.FETCH_ASSISTANT_CANCEL,
  payload: taskId
})

export const fetchAssistant = (payload, slicePreviousTurnsTo = undefined) => {
  return {
    type: constants.FETCH_ASSISTANT,
    payload: {
      ...payload,
      slicePreviousTurnsTo
    }
  }
}

export const fetchAssistantSessions = payload => ({
  type: constants.FETCH_ASSISTANT_SESSIONS,
  payload
})

export const fetchAllAssistantSessions = () => ({
  type: constants.FETCH_ALL_ASSISTANT_SESSIONS
})

export const shareAssistantSession = () => ({
  type: constants.SHARE_ASSISTANT_SESSION
})

export const setPendingShareSessionId = sessionId => ({
  type: constants.SET_PENDING_SHARE_SESSION_ID,
  payload: sessionId
})

export const fetchSharedAssistantSessions = payload => ({
  type: constants.FETCH_SHARED_ASSISTANT_SESSION,
  payload
})

export const newSession = (payload = {}) => ({
  type: constants.NEW_SESSION,
  payload
})

export const downloadReferences = payload => ({
  type: constants.DOWNLOAD_ASSISTANT_REFERENCES,
  payload
})

export const downloadTranscript = payload => ({
  type: constants.DOWNLOAD_ASSISTANT_TRANSCRIPT,
  payload
})

export const loadAssistantSettings = () => ({
  type: constants.LOAD_ASSISTANT_SETTINGS
})

export const setAssistantSettings = payload => ({
  type: constants.SET_ASSISTANT_SETTINGS,
  payload
})

export const setFeedback = payload => ({
  type: constants.SET_FEEDBACK,
  payload
})

export const setCurrentTurn = payload => ({
  type: constants.SET_CURRENT_TURN,
  payload
})

export const setSharedCurrentTurn = payload => ({
  type: constants.SET_SHARED_CURRENT_TURN,
  payload
})

// SCI-3706: marks the session whose first answer was revealed by signing up
export const setUnlockedSession = sessionId => ({
  type: constants.SET_UNLOCKED_SESSION,
  payload: sessionId
})

export const setColumns = payload => ({
  type: constants.SET_COLUMNS,
  payload
})

// SCI-4431: serialize V2 column mutations (add/edit/delete/retry) so a second one
// can't fire while one is in flight — each returns the whole table and last-write
// wins, which would silently revert a concurrent cell retry.
export const setColumnBusy = payload => ({
  type: constants.SET_COLUMN_BUSY,
  payload
})

export const setColumnForm = payload => ({
  type: constants.SET_COLUMN_FORM,
  payload
})

export const setColumnWizard = payload => ({
  type: constants.SET_COLUMN_WIZARD,
  payload
})

export const setSearchStrategyTurnIndex = payload => ({
  type: constants.SET_SEARCH_STRATEGY_TURN_INDEX,
  payload
})

export const setExportStructuredOutputTurnIndex = payload => ({
  type: constants.SET_EXPORT_STRUCTURED_OUTPUT_TURN_INDEX,
  payload
})

export const exportStructuredOutputCSV = opts => ({
  type: constants.EXPORT_STRUCTURED_OUTPUT_CSV,
  payload: opts
})

export const setChatHistoryOpen = payload => ({
  type: constants.SET_CHAT_HISTORY_OPEN,
  payload
})

export const clearResponseJustCompleted = () => ({
  type: constants.CLEAR_RESPONSE_JUST_COMPLETED
})

export const saveAssistantPreset = payload => ({
  type: constants.SAVE_ASSISTANT_PRESET,
  payload
})

export const loadAssistantPresets = () => ({
  type: constants.LOAD_ASSISTANT_PRESETS
})

export const deleteAssistantPreset = id => ({
  type: constants.DELETE_ASSISTANT_PRESET,
  payload: { id }
})

export const updateAssistantPreset = (id, data) => ({
  type: constants.UPDATE_ASSISTANT_PRESET,
  payload: { id, ...data }
})

export const startDocumentUpload = ({ uploadId, file, fileName }) => ({
  type: constants.START_DOCUMENT_UPLOAD,
  payload: { uploadId, file, fileName }
})

export const documentUploadProgress = ({ uploadId, progress, progressMessage }) => ({
  type: constants.DOCUMENT_UPLOAD_PROGRESS,
  payload: { uploadId, progress, progressMessage }
})

export const documentUploadTaskId = ({ uploadId, taskId }) => ({
  type: constants.DOCUMENT_UPLOAD_TASK_ID,
  payload: { uploadId, taskId }
})

export const documentUploadSuccess = ({ uploadId, taskId }) => ({
  type: constants.DOCUMENT_UPLOAD_SUCCESS,
  payload: { uploadId, taskId }
})

export const documentUploadFailure = ({ uploadId, fileName, message }) => ({
  type: constants.DOCUMENT_UPLOAD_FAILURE,
  payload: { uploadId, fileName, message }
})

export const cancelDocumentUpload = ({ uploadId }) => ({
  type: constants.CANCEL_DOCUMENT_UPLOAD,
  payload: { uploadId }
})

export const clearLastUploadError = () => ({
  type: constants.CLEAR_LAST_UPLOAD_ERROR
})

// `exclude` lists suggestions already shown (passed on a manual refresh) so the
// model returns a genuinely different set instead of repeating itself.
export const generateSuggestedQuestions = (turnIndex, { silent = false, exclude = [] } = {}) => ({
  type: constants.GENERATE_SUGGESTED_QUESTIONS,
  payload: { turnIndex, silent, exclude }
})

// `silent` regenerates in the background without blanking the currently shown
// suggestions to a "Thinking…" skeleton (used for stale-while-revalidate).
// `exclude` (on a manual refresh) tells the model to avoid repeating those.
export const generateSuggestedPrompts = ({ titles, key, silent = false, exclude = [] }) => ({
  type: constants.GENERATE_SUGGESTED_PROMPTS,
  payload: { titles, key, silent, exclude }
})

export const generateCollectionSuggestedPrompts = ({ collectionName, titles, key, silent = false, exclude = [] }) => ({
  type: constants.GENERATE_COLLECTION_SUGGESTED_PROMPTS,
  payload: { collectionName, titles, key, silent, exclude }
})

export const hydrateSuggestedPrompts = ({ items, key }) => ({
  type: constants.GENERATE_SUGGESTED_PROMPTS_SUCCESS,
  payload: { items, key }
})

export const hydrateCollectionSuggestedPrompts = ({ items, key }) => ({
  type: constants.GENERATE_COLLECTION_SUGGESTED_PROMPTS_SUCCESS,
  payload: { items, key }
})
